export default "__VITE_ASSET__Ckzjo9tx__"